import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {EntityBreak} from '../entity/entity-break';
import {GoogleService} from './google-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Service()
export class EntityBreakService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getBreaks(key: EntityKey): Observable<EntityBreak[]> {
    let url = this.urlBase + 'entityBreaks/' + key.entityId + '/' + key.entityRevision;
    return this.http.get<EntityBreak[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public deleteBreak(entityBreak: EntityBreak): Observable<any> {
    let url = this.urlBase + 'entityBreaks/delete';
    let body = JSON.stringify(entityBreak);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public update(entityBreak: EntityBreak): Observable<EntityBreak> {
    let url = this.urlBase + 'entityBreaks/update';
    let body = JSON.stringify(entityBreak);
    return this.http.post<EntityBreak>(url, body, {headers: this.getPostHeaders()});
  }

}
